import { render, staticRenderFns } from "./SchedulesPage.vue?vue&type=template&id=249d2725&scoped=true&"
import script from "./SchedulesPage.vue?vue&type=script&lang=ts&"
export * from "./SchedulesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249d2725",
  null
  
)

export default component.exports